import React from 'react';
import { IntroScreen } from './components/IntroScreen';
import { HookScreen } from './components/HookScreen';
import { CorePrincipleScreen } from './components/CorePrincipleScreen';
import { CommitmentCurveScreen } from './components/CommitmentCurveScreen';
import { CheStructureScreen } from './components/CheStructureScreen';
import { CheMenuScreen } from './components/CheMenuScreen';
import { Che2StructureScreen } from './components/Che2StructureScreen';
import { ClosingScreen } from './components/ClosingScreen';
export function App() {
  return <div className="w-full bg-white text-slate-900 overflow-x-hidden selection:bg-purple-200 selection:text-purple-900" data-id="element-0">
      <img src="https://cdn.magicpatterns.com/uploads/dfRAppH2d2zZ685F7e4fCm/image.png" alt="Snakker" className="fixed bottom-5 right-5 h-6 opacity-40 hover:opacity-80 transition-opacity z-50" data-id="element-1" />
      <main data-id="element-2">
        <IntroScreen data-id="element-3" />
        <HookScreen data-id="element-4" />
        <CorePrincipleScreen data-id="element-5" />
        <CommitmentCurveScreen data-id="element-6" />
        <Che2StructureScreen data-id="element-7" />
        <CheMenuScreen data-id="element-8" />
        <CheStructureScreen data-id="element-9" />
        <ClosingScreen data-id="element-10" />
      </main>
    </div>;
}